<template>
  <v-select
    v-if="itemsReady"
    v-model="categories"
    :attach="attach"
    single-line
    :placeholder="$t('categoría')"
    :items="items"
    :color="color"
    item-text="name"
    :item-value="itemValue"
    clearable
    :label="$t('Categoría')"
    :multiple="multiple"
    v-bind="$attrs"
    :box="box"
    :solo="defaultSolo"
    :outline="outline"
    @input="onSelected"
  >
    <template slot="selection" slot-scope="{ item }">
      <span class="mr-1">
        <category-icon :category="item"></category-icon>
        {{ item.name }}
      </span>
    </template>
  </v-select>
</template>

<script>
import CategoryApi from '@/services/api/category.js';
import categoryIcon from './CategoryIcon';
export default {
  components: {
    categoryIcon,
  },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
    },
    value: {
      type: [String, Array, Number, Object],
    },
    itemValue: {
      type: String,
      default: 'slug',
    },
    solo: {
      type: Boolean,
    },
    box: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    attach: {
      type: [Boolean, String],
      default: false,
    },
  },

  data() {
    return {
      categories: this.value,
      items: [],
      itemsReady: false,
    };
  },
  computed: {
    defaultSolo() {
      if (!this.box && !this.outline) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.itemsReady = false;

    CategoryApi.index().then(res => {
      this.items = res.data;
      this.itemsReady = true;
    });
  },
  methods: {
    onSelected() {
      this.$emit('input', this.categories);
    },
  },
  watch: {
    items: {
      handler: function(val, oldVal) {
        console.log({ items: this.items });
      },
      deep: true,
    },
    value: {
      handler: function(val, oldVal) {
        console.log({ value: val });
        this.categories = val;
      },
      deep: true,
    },
  },
};
</script>

<style></style>
